import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon, GiftIcon, CheckIcon, ChevronDownIcon, LockIcon, SmartphoneIcon, CreditCardIcon } from 'lucide-react';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/wfCwzazkJgFyupSqRqJKQJ/heylloyd-image-1771802598740_reset_cortisol.png';
const BONUS_1_IMG = 'https://cdn.magicpatterns.com/uploads/jYW7AwDJmZK8DYTcxYwyMP/heylloyd-image-1773015601413_port_bono1.png';
const BONUS_2_IMG = 'https://cdn.magicpatterns.com/uploads/nrkvf634uKhnnZZD2g4UAK/heylloyd-image-1773015622862_port_bono2.png';
const BONUS_3_IMG = 'https://cdn.magicpatterns.com/uploads/mMtKQtynhoa89sdwDdop6t/heylloyd-image-1773015694376_port_bono_3.png';
export function OfferSection({
  onAddToCart
}: {
  onAddToCart?: () => void;
}) {
  const [expandedBonus, setExpandedBonus] = useState<number | null>(null);
  const toggleBonus = (index: number) => {
    setExpandedBonus(expandedBonus === index ? null : index);
  };
  return <section id="offer-section" className="bg-forest py-16 md:py-24" aria-labelledby="offer-heading" data-id="element-275" data-mp="12ns0v29366w0">
      <div className="max-w-5xl mx-auto px-4" data-id="element-276" data-mp="xv8r6gdirvwh">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-277" data-mp="sxfklm8b0zvo">
          <p className="font-sans text-terracotta text-xs font-700 tracking-[0.2em] uppercase mb-4" data-id="element-278" data-mp="1gnt24it9jgc0">
            Today's Offer
          </p>
          <h2 id="offer-heading" className="font-serif text-cream text-3xl md:text-4xl lg:text-5xl font-700 leading-tight" data-id="element-279" data-mp="17mlhh3jo6e0e">
            Get the Complete Cortisol Reset Kitchen System
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-center" data-id="element-280" data-mp="3sb980aecjgtf">
          {/* Value Stack */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-281" data-mp="3trwsqyb0196t">
            {/* Main Product Items */}
            <ul className="space-y-4 mb-6" role="list" data-id="element-282" data-mp="3b1x9is1uaobb">
              <li className="flex items-start gap-3" data-id="element-283" data-mp="3fuqcpbhntola">
                <CheckCircleIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-284" data-mp="3fvjdzwxunlw1" />
                <span className="font-sans text-cream text-base" data-id="element-285" data-mp="365gklvmtg5x6">
                  The 21-Day Thermal Window Flush{' '}
                  <span className="text-sage text-sm" data-id="element-286" data-mp="2s55rely1af8u">($47 value)</span>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-287" data-mp="2x2xmfotz6hh9">
                <CheckCircleIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-288" data-mp="2dh5gpz80bs1b" />
                <span className="font-sans text-cream text-base" data-id="element-289" data-mp="28l6t4dui6e1y">
                  The Sleep-to-Slim Connection Protocol{' '}
                  <span className="text-sage text-sm" data-id="element-290" data-mp="2igi9t1ph1vcc">($27 value)</span>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-291" data-mp="2wfrg99nvlb34">
                <CheckCircleIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-292" data-mp="2wegeffdzqden" />
                <span className="font-sans text-cream text-base" data-id="element-293" data-mp="3662wnvoqxcqw">
                  The Adrenal Grocery List{' '}
                  <span className="text-sage text-sm" data-id="element-294" data-mp="318b3kycd7kl4">($17 value)</span>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-295" data-mp="3f4y398vpcouq">
                <CheckCircleIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-296" data-mp="3a98zetcnglsm" />
                <span className="font-sans text-cream text-base" data-id="element-297" data-mp="1dhv7tu48cuce">
                  40+ Anti-Inflammatory Recipes{' '}
                  <span className="text-sage text-sm" data-id="element-298" data-mp="1i8lc140x6r5i">($37 value)</span>
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-299" data-mp="1m9do0516fa5h">
                <CheckCircleIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-300" data-mp="pk5zco59gkxc" />
                <span className="font-sans text-cream text-base" data-id="element-301" data-mp="ujsnhsmmnlkx">
                  <span className="text-terracotta font-700" data-id="element-302" data-mp="ykkyaqb5dyjb">BONUS:</span>{' '}
                  Cortisol SOS Guide{' '}
                  <span className="text-sage text-sm" data-id="element-303" data-mp="13kqhdi3cqcps">($17 value — FREE)</span>
                </span>
              </li>
            </ul>

            {/* Bonus Divider */}
            <div className="border-t border-white/15 my-6" data-id="element-304" data-mp="2eykubq6vh41a" />
            <p className="font-sans text-terracotta text-xs font-700 tracking-[0.2em] uppercase mb-4 flex items-center gap-2" data-id="element-305" data-mp="2f171vptrjjji">
              <GiftIcon className="w-4 h-4" aria-hidden="true" data-id="element-306" data-mp="2k47y8vkpr271" />3 FREE
              Companion Guides Included
            </p>

            {/* Bonus Items with Expandable Details */}
            <div className="space-y-3 mb-8" data-id="element-307" data-mp="2bbmf3ed66tho">
              {/* Bonus 1 */}
              <div className="rounded-xl border border-white/15 overflow-hidden" data-id="element-308" data-mp="2bbe3dpss9u82">
                <button onClick={() => toggleBonus(1)} className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left transition-colors hover:bg-white/5" data-id="element-309" data-mp="26e4fiel1lqmc">
                  <div className="flex items-start gap-3" data-id="element-310" data-mp="1wgga8upt90px">
                    <GiftIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-311" data-mp="1sdtnh87zy5zl" />
                    <span className="font-sans text-cream text-base" data-id="element-312" data-mp="3mq9qm05hx408">
                      The Restaurant Survival Blueprint{' '}
                      <span className="text-sage text-sm" data-id="element-313" data-mp="1k3chy09iwr2u">
                        ($27 value — FREE)
                      </span>
                    </span>
                  </div>
                  <div className="flex items-center gap-1.5 flex-shrink-0" data-id="element-314" data-mp="1b48z8xe9qdov">
                    <span className="font-sans text-terracotta text-xs font-700 hidden sm:inline" data-id="element-315" data-mp="1f4rrutnzjns4">
                      {expandedBonus === 1 ? 'Close' : 'Read More'}
                    </span>
                    <ChevronDownIcon className={`w-4 h-4 text-terracotta transition-transform duration-300 ${expandedBonus === 1 ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-316" data-mp="27tq9lpo74nww" />
                  </div>
                </button>
                <AnimatePresence data-id="element-317" data-mp="1yuv5cj4ppnw8">
                  {expandedBonus === 1 && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} className="overflow-hidden" data-id="element-318" data-mp="idh6yb0bq96t">
                      <div className="px-4 pb-5 border-t border-white/10" data-id="element-319" data-mp="3ncxzsw6zjy6z">
                        <img src={BONUS_1_IMG} alt="The Restaurant Survival Blueprint" className="w-full max-w-xs rounded-xl mt-4 mb-4 shadow-md" data-id="element-320" data-mp="3nalce3igkvmj" />
                        <p className="font-sans text-cream/80 text-sm italic mb-3" data-id="element-321" data-mp="39k81bsa9t0sz">
                          "How to Dine Out Without Triggering a 48-Hour Cortisol
                          Bloat"
                        </p>
                        <div className="font-sans text-cream/70 text-sm space-y-2 mb-4" data-id="element-322" data-mp="2j4es3sxn896n">
                          <p data-id="element-323" data-mp="2o2q3w97i0tri">
                            Most women over 55 quietly dread dinner invitations.
                            Not because they do not want the friendship — but
                            because they know what happens the next morning.
                          </p>
                          <p data-id="element-324" data-mp="320y6awnb0na2">
                            <strong className="text-cream" data-id="element-325" data-mp="31zn1cti4h9hd">
                              It is not the portion size that is the problem.
                            </strong>{' '}
                            It is the hidden cortisol triggers inside restaurant
                            kitchens.
                          </p>
                        </div>
                        <ul className="space-y-2" data-id="element-326" data-mp="3lqqc0pj4cq7n">
                          <li className="flex items-start gap-2" data-id="element-327" data-mp="3lnvvva751rk1">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-328" data-mp="3prtqb7liqe6r" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-329" data-mp="1a120vfc90rur">
                              <strong className="text-cream" data-id="element-330" data-mp="1541ut4fefp3n">
                                The 5-Second Menu Decoder
                              </strong>{' '}
                              — instantly identify cortisol-spiking ingredients
                            </span>
                          </li>
                          <li className="flex items-start gap-2" data-id="element-331" data-mp="1std111fiqbp6">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-332" data-mp="1o1ctonx4cgik" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-333" data-mp="2gip4dko5zpjk">
                              <strong className="text-cream" data-id="element-334" data-mp="2brz0yczatwri">
                                The Cuisine-by-Cuisine Safe List
                              </strong>{' '}
                              — Italian, Mexican, Asian, American
                            </span>
                          </li>
                          <li className="flex items-start gap-2" data-id="element-335" data-mp="99cinadbhzfn">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-336" data-mp="97jd5yefxl98" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-337" data-mp="i7xzn13556eb">
                              <strong className="text-cream" data-id="element-338" data-mp="daxv4ulxwbpb">
                                The Anti-Inflammatory Bar Order
                              </strong>{' '}
                              — what to drink and still feel social
                            </span>
                          </li>
                          <li className="flex items-start gap-2" data-id="element-339" data-mp="1111wevbnnzd5">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-340" data-mp="x087pzqe2gj7" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-341" data-mp="1klakapwbk5p7">
                              <strong className="text-cream" data-id="element-342" data-mp="16nlzfi294yk5">
                                The Morning-After Reset Protocol
                              </strong>{' '}
                              — wake up lighter after a dinner out
                            </span>
                          </li>
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>

              {/* Bonus 2 */}
              <div className="rounded-xl border border-white/15 overflow-hidden" data-id="element-343" data-mp="rxerhw9vexxp">
                <button onClick={() => toggleBonus(2)} className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left transition-colors hover:bg-white/5" data-id="element-344" data-mp="dy5cv11bcbvu">
                  <div className="flex items-start gap-3" data-id="element-345" data-mp="2kmnqm03kvysv">
                    <GiftIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-346" data-mp="2ko8nhwdd7ttw" />
                    <span className="font-sans text-cream text-base" data-id="element-347" data-mp="2bulqk2xf8kj4">
                      The 11 PM Emergency Snack List{' '}
                      <span className="text-sage text-sm" data-id="element-348" data-mp="26t67uhipuq3w">
                        ($19 value — FREE)
                      </span>
                    </span>
                  </div>
                  <div className="flex items-center gap-1.5 flex-shrink-0" data-id="element-349" data-mp="2zkg82xsoqx9p">
                    <span className="font-sans text-terracotta text-xs font-700 hidden sm:inline" data-id="element-350" data-mp="2uja8cg0ly9qo">
                      {expandedBonus === 2 ? 'Close' : 'Read More'}
                    </span>
                    <ChevronDownIcon className={`w-4 h-4 text-terracotta transition-transform duration-300 ${expandedBonus === 2 ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-351" data-mp="1j67uhspw7ya7" />
                  </div>
                </button>
                <AnimatePresence data-id="element-352" data-mp="190os13m4j0wa">
                  {expandedBonus === 2 && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} className="overflow-hidden" data-id="element-353" data-mp="1e0uiwhkkkjdb">
                      <div className="px-4 pb-5 border-t border-white/10" data-id="element-354" data-mp="2ecnu5qvbegb">
                        <img src={BONUS_2_IMG} alt="The 11 PM Emergency Snack List" className="w-full max-w-xs rounded-xl mt-4 mb-4 shadow-md" data-id="element-355" data-mp="7bclbs9nj8vt" />
                        <p className="font-sans text-cream/80 text-sm italic mb-3" data-id="element-356" data-mp="1sw99on3k0q6n">
                          "12 Cortisol-Lowering Snacks That Help You Sleep
                          Deeper and Wake Up Lighter"
                        </p>
                        <div className="font-sans text-cream/70 text-sm space-y-2 mb-4" data-id="element-357" data-mp="1e4qw0vy637qg">
                          <p data-id="element-358" data-mp="1a3xauac40719">
                            When you go to bed with low blood sugar, your
                            cortisol surges to compensate. That surge is the
                            exact reason you wake up at 3 AM.
                          </p>
                          <p data-id="element-359" data-mp="1j28zi6tf0ur2">
                            <strong className="text-cream" data-id="element-360" data-mp="ve9772gggwad">
                              Going to bed hungry is not discipline. It is a
                              cortisol event.
                            </strong>
                          </p>
                        </div>
                        <ul className="space-y-2" data-id="element-361" data-mp="3216w8sj37uhg">
                          <li className="flex items-start gap-2" data-id="element-362" data-mp="36uji4uwdtn6i">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-363" data-mp="2t2v6esq1p0q2" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-364" data-mp="3lqhb64b0ebei">
                              <strong className="text-cream" data-id="element-365" data-mp="3pslxehz4o5r4">
                                The Safety Boat Snack
                              </strong>{' '}
                              — 1 ingredient, 60 seconds, signals your adrenals
                              to stand down
                            </span>
                          </li>
                          <li className="flex items-start gap-2" data-id="element-366" data-mp="20cwempkguphp">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-367" data-mp="25dabdbgmad0f" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-368" data-mp="1h8sun2mvhoh5">
                              <strong className="text-cream" data-id="element-369" data-mp="1ci2qfsq6nro1">
                                The Melatonin Precursor Combo
                              </strong>{' '}
                              — puts your body into fat-burning sleep mode
                            </span>
                          </li>
                          <li className="flex items-start gap-2" data-id="element-370" data-mp="xlbqniclkdxw">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-371" data-mp="xn6bkwnvc61z" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-372" data-mp="omq83n74kyx4">
                              <strong className="text-cream" data-id="element-373" data-mp="2nwq008yy7s3y">
                                The No-Go After-9 PM List
                              </strong>{' '}
                              — 3 foods secretly spiking your cortisol all night
                            </span>
                          </li>
                          <li className="flex items-start gap-2" data-id="element-374" data-mp="2vexlgx5cb9tv">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-375" data-mp="3091vxqdtdzzp" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-376" data-mp="27kczw5rm8kut">
                              <strong className="text-cream" data-id="element-377" data-mp="2chd0i15p4vej">
                                The 4-Step Cortisol Shutdown Protocol
                              </strong>{' '}
                              — your new nightly closing ritual
                            </span>
                          </li>
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>

              {/* Bonus 3 */}
              <div className="rounded-xl border border-white/15 overflow-hidden" data-id="element-378" data-mp="mtcjlsupi6y9">
                <button onClick={() => toggleBonus(3)} className="w-full flex items-center justify-between gap-3 px-4 py-3 text-left transition-colors hover:bg-white/5" data-id="element-379" data-mp="hvb0j7xa67ms">
                  <div className="flex items-start gap-3" data-id="element-380" data-mp="rs7ali2tv1tg">
                    <GiftIcon className="w-5 h-5 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-381" data-mp="15kn7001841le" />
                    <span className="font-sans text-cream text-base" data-id="element-382" data-mp="10lan9o5nfan1">
                      The 7-Minute Metabolic Spark{' '}
                      <span className="text-sage text-sm" data-id="element-383" data-mp="1ajqbnjdak5su">
                        ($29 value — FREE)
                      </span>
                    </span>
                  </div>
                  <div className="flex items-center gap-1.5 flex-shrink-0" data-id="element-384" data-mp="3hcadfcfv5sgs">
                    <span className="font-sans text-terracotta text-xs font-700 hidden sm:inline" data-id="element-385" data-mp="3ccnymyke045v">
                      {expandedBonus === 3 ? 'Close' : 'Read More'}
                    </span>
                    <ChevronDownIcon className={`w-4 h-4 text-terracotta transition-transform duration-300 ${expandedBonus === 3 ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-386" data-mp="1wqu74a5avam0" />
                  </div>
                </button>
                <AnimatePresence data-id="element-387" data-mp="191hx5825eyin">
                  {expandedBonus === 3 && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3,
                  ease: 'easeInOut'
                }} className="overflow-hidden" data-id="element-388" data-mp="1d4o1ub9m4hn0">
                      <div className="px-4 pb-5 border-t border-white/10" data-id="element-389" data-mp="aokk9s2lq5aq">
                        <img src={BONUS_3_IMG} alt="The 7-Minute Metabolic Spark" className="w-full max-w-xs rounded-xl mt-4 mb-4 shadow-md" data-id="element-390" data-mp="3t20if15m9mfg" />
                        <p className="font-sans text-cream/80 text-sm italic mb-3" data-id="element-391" data-mp="oko7v2iyzfe8">
                          "The Joint-Safe Morning Routine That Wakes Up Your
                          Thyroid Without Spiking Your Stress Hormones"
                        </p>
                        <div className="font-sans text-cream/70 text-sm space-y-2 mb-4" data-id="element-392" data-mp="kk4apyyecbs3">
                          <p data-id="element-393" data-mp="30c1x9gujm9g2">
                            It is 7 minutes. In your pajamas. Barefoot, if you
                            want. A cortisol-conscious movement protocol
                            designed specifically for women over 55.
                          </p>
                          <p data-id="element-394" data-mp="2stby0i5g3uuh">
                            <strong className="text-cream" data-id="element-395" data-mp="2ss0t2f09kh1s">
                              No jumping. No equipment. No joint pain.
                            </strong>
                          </p>
                        </div>
                        <ul className="space-y-2" data-id="element-396" data-mp="31re5ngjoplqq">
                          <li className="flex items-start gap-2" data-id="element-397" data-mp="2e34q2wd2du81">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-398" data-mp="294tfgjey3for" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-399" data-mp="2j2zgyzwuajt3">
                              <strong className="text-cream" data-id="element-400" data-mp="2j0wirslj9kda">
                                The 4-Movement Release Circuit
                              </strong>{' '}
                              — 90 seconds each, zero impact, any room
                            </span>
                          </li>
                          <li className="flex items-start gap-2" data-id="element-401" data-mp="3qeqonoqvkozo">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-402" data-mp="3ve3b48du3u1q" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-403" data-mp="822dj23e5x9m">
                              <strong className="text-cream" data-id="element-404" data-mp="37iqrlzj1iv98">
                                The 2 Thermal Window Timing Slots
                              </strong>{' '}
                              — when these 7 minutes burn 3x more
                            </span>
                          </li>
                          <li className="flex items-start gap-2" data-id="element-405" data-mp="3li9qe1pyou8v">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-406" data-mp="vseoymxuic4y" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-407" data-mp="1avplocpqf7q8">
                              <strong className="text-cream" data-id="element-408" data-mp="15w38225zrpgw">
                                The Exhale Rhythm Rule
                              </strong>{' '}
                              — know if you are helping or hurting your cortisol
                            </span>
                          </li>
                          <li className="flex items-start gap-2" data-id="element-409" data-mp="s4f0mc6otp69">
                            <CheckIcon className="w-4 h-4 text-terracotta flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-410" data-mp="s2lqgmwv8mti" />
                            <span className="font-sans text-cream/80 text-sm" data-id="element-411" data-mp="i8lfw5itepde">
                              <strong className="text-cream" data-id="element-412" data-mp="e6i3neobngr2">
                                The Energy Check-In Guide
                              </strong>{' '}
                              — know within 60 seconds if your body is
                              responding
                            </span>
                          </li>
                        </ul>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </div>

            {/* Price */}
            <div className="bg-white/10 rounded-2xl p-6 mb-6 border border-white/20" data-id="element-413" data-mp="2ams0s66gnfvd">
              <p className="font-sans text-sage text-sm mb-1" data-id="element-414" data-mp="2aowbp82s1f55">Total Value:</p>
              <p className="font-serif text-cream/60 text-2xl line-through mb-1" data-id="element-415" data-mp="1wuc21hkle409">
                $220
              </p>
              <p className="font-serif text-cream text-4xl font-700" data-id="element-416" data-mp="1mxh7tavcqprs">
                Today Only: <span className="text-terracotta" data-id="element-417" data-mp="1mve982g4vobg">$6.36</span>
              </p>
              <p className="font-sans text-sage text-sm mt-2" data-id="element-418" data-mp="1rx3jhfvj7xyh">
                The price of one lunch. The solution you've been searching for.
              </p>
            </div>

            {/* CTA */}
            <a href="https://buenavibrax.com/cart/45502602674233:1" target="_top" rel="noopener" onClick={() => onAddToCart?.()} className="block w-full bg-terracotta hover:bg-terracotta/90 text-white font-sans font-700 text-lg px-8 py-4 rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl hover:-translate-y-0.5 mb-5 text-center" aria-label="Get instant access to the Cortisol Reset Kitchen for $6.36" data-id="element-419" data-mp="1ivcde9x2xp43">
              YES! Give Me Instant Access for $6.36 →
            </a>

            {/* Trust Badges */}
            <div className="flex flex-wrap justify-center gap-4 text-sage text-sm font-sans" data-id="element-420" data-mp="1d7r2frkrkjjl">
              <span className="flex items-center gap-1.5" data-id="element-421" data-mp="1s0u8p2swnav0">
                <LockIcon className="w-4 h-4" aria-hidden="true" data-id="element-422" data-mp="1n0pszeztmk5u" />
                Secure Checkout
              </span>
              <span className="flex items-center gap-1.5" data-id="element-423" data-mp="20zz625sqcy5l">
                <SmartphoneIcon className="w-4 h-4" aria-hidden="true" data-id="element-424" data-mp="1w0uyfjlgf8hd" />
                Instant Download
              </span>
              <span className="flex items-center gap-1.5" data-id="element-425" data-mp="to86hc5kbfgf">
                <CreditCardIcon className="w-4 h-4" aria-hidden="true" data-id="element-426" data-mp="ylrwf9bmhgo7" />
                All Cards Accepted
              </span>
            </div>
          </motion.div>

          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.1
        }} className="flex justify-center" data-id="element-427" data-mp="17e3b5xxdjfoc">
            <div className="relative" data-id="element-428" data-mp="1qdpis9z1vzr3">
              <div className="absolute inset-0 bg-terracotta/20 rounded-3xl blur-2xl transform scale-90 translate-y-6" aria-hidden="true" data-id="element-429" data-mp="1qco0bkfpgazc" />
              <img src={PRODUCT_IMAGE} alt="The Cortisol Reset Kitchen digital guide" className="relative w-full max-w-xs rounded-2xl shadow-2xl" data-id="element-430" data-mp="3s5c53y7zz6h8" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}